import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatChipInputEvent } from "@angular/material/chips";

@Component({
    selector: 'version-selector',
    templateUrl: 'version-selector.component.html',
    styleUrls: ['version-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
  export class VersionSelectorComponent {
    @Input() parentFormGroup: FormGroup;
    @Input() controlName: string;

    versionInputControl: FormControl<string> = new FormControl<string>('');

    addChip(event: MatChipInputEvent): void {
        const value = event.value;
    
        if ((value || '').trim()) {
          const chipsControl = this.parentFormGroup.get(this.controlName);
          const chips = (chipsControl.value as string[] | null) ?? [];
          chipsControl.setValue([...chips, value.trim()]);
          chipsControl.markAsDirty();
        }

        this.versionInputControl.setValue('');
      }
    
      removeChip(chip: string): void {
        const chipsControl = this.parentFormGroup.get(this.controlName);
        const chips = (chipsControl.value as string[] | null) ?? [];
        const index = chips.indexOf(chip);
    
        if (index >= 0) {
          chipsControl.setValue(chips.filter((_, chipIndex) => chipIndex !== index));
          chipsControl.markAsDirty();
        }
      }
  }
